import React from 'react'
import cn from 'classnames'
import styles from 'components/quests/quest-options-header.module.scss'
import { X } from 'lucide-react'

export default function QuestOptionsHeader(props) {
    const closeQuestOptions = ev => {
        ev.stopPropagation()
        ev.preventDefault()

        if (props.close) props.close()
    }

    return (
        <div
            className={cn(
                styles.questOptionsHeader,
                props.compact && styles.compact,
                props.className,
            )}
        >
            <div className={styles.questOptionsTitle}>{props.title}</div>

            {props.close && (
                <div className={styles.questOptionsToggle} onClick={closeQuestOptions}>
                    <X size={16} />
                </div>
            )}
        </div>
    )
}
